/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IndiceDto } from './IndiceDto';
import {
    IndiceDtoFromJSON,
    IndiceDtoFromJSONTyped,
    IndiceDtoToJSON,
    IndiceDtoToJSONTyped,
} from './IndiceDto';

/**
 * Résultat paginé de la recherche d'indices.
 * @export
 * @interface SearchIndicesResponse
 */
export interface SearchIndicesResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchIndicesResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<IndiceDto>}
     * @memberof SearchIndicesResponse
     */
    items?: Array<IndiceDto>;
}

/**
 * Check if a given object implements the SearchIndicesResponse interface.
 */
export function instanceOfSearchIndicesResponse(value: object): value is SearchIndicesResponse {
    return true;
}

export function SearchIndicesResponseFromJSON(json: any): SearchIndicesResponse {
    return SearchIndicesResponseFromJSONTyped(json, false);
}

export function SearchIndicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchIndicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(IndiceDtoFromJSON)),
    };
}

export function SearchIndicesResponseToJSON(json: any): SearchIndicesResponse {
    return SearchIndicesResponseToJSONTyped(json, false);
}

export function SearchIndicesResponseToJSONTyped(value?: SearchIndicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(IndiceDtoToJSON)),
    };
}

